/**
 * TODO:
 * Add styles for add to cart v2 . Be careful with the new labels
 */
import React from 'react';
import { useTranslation } from 'Shared/Hooks/useTranslation';
import { ProductsContext } from 'Jsx/ContextApis/Products';
import ShoppingCartLight from 'crehana-icons/ShoppingCartLight';
import ShoppingCartAddedIcon from 'crehana-icons/ShoppingCartAdded';
import InverseButton from 'crehana-ui/Buttons/InverseButton';
import Check2 from 'crehana-icons/Check2';
import locales from '../../../i18n/localeEs';

const translations = locales.es;

type AddToCartBtnProps = {
  courseId: number;
  id?: string;
  addToCartLabel?: string;
  className?: string;
  fromSticky?: boolean;
  addToCartTheme: 'a' | 'b';
  size?: string;
};

const AddToCartBtn: React.FC<AddToCartBtnProps> = ({
  id,
  addToCartLabel,
  courseId,
  className,
  fromSticky,
  addToCartTheme,
  size = 'm',
}) => {
  const { t } = useTranslation();

  const {
    shoppingCartState: { loadingCartMutation, courseIdsInCart },
    addCourseToCart,
    removeCourseFromCart,
  } = React.useContext(ProductsContext);
  const addCourse = () => {
    try {
      if (window.gtag) {
        window.gtag('event', 'Add to shopping cart', {
          send_to: 'UA-60829200-1',
          event_category: 'PAYG',
          event_label: 'shopping cart',
        });
      }
    } catch (error) {
      console.log(error);
    }
    addCourseToCart({ courseId });
  };

  const removeCourse = () => {
    removeCourseFromCart({ courseId });
  };

  const isInShoppingCart = courseIdsInCart.includes(courseId);

  const toggleAddToCart = isInShoppingCart ? removeCourse : addCourse;

  if (fromSticky) {
    return (
      <InverseButton
        gray={!isInShoppingCart}
        leftIcon={{
          component: isInShoppingCart
            ? ShoppingCartAddedIcon
            : ShoppingCartLight,
          size: 24,
        }}
        className="mr-12 px-24"
        onClick={toggleAddToCart}
        aria-label="add-cart"
      />
    );
  }

  const getLabel = () => {
    if (isInShoppingCart) {
      if (loadingCartMutation) {
        return t('REMOVING', {
          defaultValue: translations.REMOVING,
        });
      }
      return t('ADDED', {
        defaultValue: translations.ADDED,
      });
    }
    if (loadingCartMutation) {
      return t('ADDING', {
        defaultValue: translations.ADDING,
      });
    }
    return (
      addToCartLabel ||
      t('ADD_TO_CART', {
        defaultValue: translations.ADD_TO_CART,
      })
    );
  };

  return (
    <InverseButton
      gray={addToCartTheme === 'b'}
      className={className}
      full
      onClick={toggleAddToCart}
      id={id}
      leftIcon={{
        component: isInShoppingCart ? Check2 : ShoppingCartLight,
        size: 24,
      }}
      label={getLabel()}
      size={size}
    />
  );
};

export default AddToCartBtn;
